/**
 * reply-message.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { AcknowledgmentResponse } from "./acknowledgment-response";
import { Message } from "./message";
export { Message } from "./message";

/* tslint:disable:max-classes-per-file */

export class ReplyVerifyingMessage extends Message
{
  public expectsReply () : boolean
  {
    return true;
  }

  public verifyReply (reply : Message) : boolean
  {
    return AcknowledgmentResponse.isOk(reply);
  }
}

export class ReplyMessage extends Message
{
  public request : ReplyVerifyingMessage;

  public verify () : boolean
  {
    return this.request.verifyReply(this);
  }

  public expectsReply () : boolean
  {
    return false;
  }

  public static create (data : Message, request : Message) : ReplyMessage
  {
    return Object.assign(new ReplyMessage(), data, {request});
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/general/reply-message.ts